import { SpacingName } from '@doveit/lego';
import React from 'react';
import { City } from '../../types';
import { requireFromStaticAsset } from '../../utils/assetsUtils';
import { goToPage } from '../../utils/links';
import CardsHList from '../cards-hlist/CardsHList';
import Tile from '../tile/Tile';

export interface CitiesHListProps {
  cities: City[],
}

const CitiesHList: React.FC<CitiesHListProps> = ({ cities }) => (
  <CardsHList
    inline={6}
    itemWidth="9rem"
    sideSpacing={SpacingName.SMALL}
  >
    {cities.map((city, i) => (
      <CardsHList.Item
        key={city.title}
        data-ref={`city-${city.title}-${i}`}
      >
        <Tile
          title={city.title}
          image={{
            src: requireFromStaticAsset(city.picture),
            alt: city.title,
          }}
          anchorTitle={city.title}
          onClick={city.urlObject ? () => goToPage(city.urlObject) : undefined}
          urlObject={city.urlObject}
          loading="lazy"
        />
      </CardsHList.Item>
    ))}
  </CardsHList>
);

export default CitiesHList;
